import React from 'react';
import './Compare.scss'
import { Link } from 'gatsby';
import bell from './icons/bell.svg';
import aiSearch from './icons/ai-search.svg';
import arrows from './icons/arrows.svg';
import documents from './icons/documents.svg';
import flag from './icons/flag.svg';
import group from './icons/group.svg';
import hammer from './icons/hammer.svg';
import karnov from './icons/karnov.svg';
import law from './icons/law.svg';
import link from './icons/link.svg';
import pencil from './icons/pencil.svg';
import search from './icons/search.svg';
import squares from './icons/squares.svg';
import db from './icons/db.svg';

const iconResolver = (name) => {
	const icons = {
		bell,
		aiSearch,
		arrows,
		documents,
		flag,
		group,
		hammer,
		karnov,
		law,
		link,
		pencil,
		search,
		squares,
		db
	};

	return <img width="24" src={icons[name]} alt="" /> || null;
}

const Point = ({title, text, icon}) => {
	return(
		<li>
			<div className="icon">
				{ icon && iconResolver(icon) }
			</div>
			<div className="text">
				<h4>{title}</h4>
				<p>{text}</p>
			</div>
		</li>
	)
}

export default function Compare() {
	return(
		<div className="Compare">
			<div className="wrapper">
				<h2>Hva skiller Lovdata fra Lovdata Pro?</h2>
				<div className="compare-tables">
					<div className="compare-table left">
						<h3>Lovdata.no</h3>
						<p>Vi vedlikeholder <a className="link" href="//lovdata.no" target="_blank" rel="noopener noreferrer">lovdata.no</a> slik at lovverket er tilgjengelig for alle – gratis og uten innlogging. Nettstedet inneholder de viktigste rettskildene som regulerer borgernes rettigheter og plikter. Informasjonen er alltid oppdatert, og omfatter lover, sentrale og lokale forskrifter, høyesteretts-  og lagmannsrettsavgjørelser og et mindre utvalg avgjørelser fra tingretten. I tillegg kan du finne tariffavtaler og avgjørelser fra Den europeiske menneskerettsdomstolen m.m.</p>
						<ul>
							<Point icon="search" title="Søk og naviger" text="Søk og naviger ved oppslag i kronologiske og alfabetiske registre." />
							<Point icon="hammer" title="Nye dommer" text="Høyesteretts- og lagmannsrettsavgjørelser er tilgjengelig tilbake til 2008, tingrettsavgjørelser og jordskifterettene er tilgjengelig tilbake til 2016. Oversatte sammendrag av avgjørelser fra Den Europeiske menneskerettsdomstol er tilgjengelige tilbake til 2016. Alt av kjennelser fra Trygderetten er tilgjengelig." />
							<Point icon="link" title="Referanser og snarveier" text="Dommene er utstyrt med lenker til de sentrale lovparagrafene." />
						</ul>
					</div>
					<div className="compare-table right">
						<h3>Lovdata Pro</h3>
						<p>Lovdata Pro er tjenesten for deg som jobber med jussen jevnlig. Her får du lynraske og presise søk og et kraffullt arbeidsverktøy. Lovdata Pro gir deg tilgang til gjeldende og historiske lover og forskrifter, forarbeider, rundskriv, nemder, avgjørelser - en enorm database av rettskilder, samlet opp og strukturert gjennom 40 år.</p>
						<p>Enten du er jurist, advokat, rådgiver eller jobber med saksbehandling i offentlig sektor, gir Lovdata Pro deg kontroll, oversikt og trygghet i arbeidshverdagen.</p>
						<ul>
							<Point icon="search" title="Lynraskt og presist søk" text="Finjuster søket med avanserte filtre og finn det du leter etter raskt." />
							<Point icon="aiSearch" title="Tilgang til KI-søk" text="Med Lovdata Pro 2 kan du finne rettskilder med naturlig språk." />
							<Point icon="documents" title="Historiske versjoner" text="Se hvordan lovteksten har endret seg og naviger mellom versjonene." />
							<Point icon="bell" title="Varsling ved endringer" text="Hold deg oppdatert på det som betyr mest for deg." />
							<Point icon="pencil" title="Personlige arbeidsverktøy" text="Marker, uthev, lag egne notater og mapper – og bygg din egen arbeidsflate." />
							<Point icon="flag" title="Flaggsaker" text="Få med deg rettskraftige, utvalgte rettsavgjørelser som er spesielt viktig å merke seg." />
							<Point icon="group" title="Deling og samarbeid" text="Opprett grupper og del dokumenter, merknader og mapper med andre." />
							<Point icon="db" title="Over 1,4 millioner dokumenter" text="Norges bredeste og dypeste samling av rettsdokumenter, arkivert og oppdatert." />
							<Point icon="arrows" title="Krysshenvisninger og relasjoner" text="Gå sømløst mellom tilknyttede lover, forarbeider og avgjørelser." />
							<Point icon="karnov" title="Karnov-kommentarer (tilleggsopsjon)" text="Inkluderer redaksjonelle kommentarer – via egen avtale med Karnov." />
						</ul>
						<div className="cta">
							<p><strong>Er noen av punktene relevante for deg i din arbeidshverdag?</strong></p>
							<p>Prøv Lovdata Pro gratis i 30 dager – og få tilgang til hele verktøykassen.</p>
							<div className="button-row">
								<Link className="Button primary" to="/prov-gratis"><span>Prøv gratis i dag</span></Link>
								<Link className="Button white" to="/fordelene-med-lovdata-pro"><span>eller les mer</span></Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}